import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const bookingNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.BOOKING,
  data: {
    type: FlowNodeTypes.BOOKING,
    settingsTitle: "Real-Time Booking",
    description: "Book an appointment",
    onChange: () => {
      console.log("Booking node changed");
    },
    settings: [
      {
        title: "General",
        expandedSetting: true,
        params: [
          {
            hidden: true,
            type: SettingParamTypes.VALUE,
            key: "action",
            value: {},
          },
          {
            label: "Email",
            placeholder: "Enter Email",
            type: SettingParamTypes.INPUT,
            key: "email",
            value: "",
          },
          {
            label: "Send Confirmation SMS",
            type: SettingParamTypes.SWITCH,
            key: "send_confirmation_sms",
            value: undefined,
          },
          {
            label: "Lead",
            placeholder: "Enter Lead Timezone",
            type: SettingParamTypes.SELECT,
            key: "lead_timezone",
            value: "",
            selectOptions: [
              {
                name: "Europe/Berlin",
                value: "Europe/Berlin",
              },
              {
                name: "America/New_York",
                value: "America/New_York",
              },
              {
                name: "America/Los_Angeles",
                value: "America/Los_Angeles",
              },
            ],
          },
        ],
      },
    ],
  },
  position: {x: 0, y: 0},
};
